









import Vue from 'vue';
import { openModal, notify } from 'mycorems-app-shared';
import { Template, SaveTemplateModalOKEvent } from '../types';
import SaveTemplateModal from './SaveTemplateModal.vue';

export default Vue.extend({
  props: {
    accountId: {
      type: String,
      required: true,
    },
    template: Object as () => Template,
    label: String,
    icon: String,
  },
  methods: {
    create(): void {
      openModal(SaveTemplateModal, {
        parent: this,
        accountId: this.accountId,
        template: this.template,
      }).onOk((event: SaveTemplateModalOKEvent) => {
        if (event.created) {
          notify.success('Note template created.');
          this.$emit('created', event.created);
        }
        if (event.edited) {
          notify.success('Note template updated.');
          this.$emit('edited', event.edited);
        }
      });
    },
  },
});
